// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"2cfa03e5","254":"18bf3db0","307":"20320ab9","483":"7b96dcb7","773":"510a6be7","927":"9c34fd80"}[chunkId] + ".chunk.js";
};